import axios from "axios";
export const getPath = (origin, distance) => {
    return axios
        .get(`${process.env.SERVER}/path/${origin.lat}/${origin.lng}/${distance}`)
        .then((response) => {
        return response.data;
    });
};
